import React, { useState, useEffect } from 'react';
import InputMask from 'react-input-mask';

//Import Store
import store from '../../../../store';

//Import Custom Component
import ValidateRepeatPasswd from '../../../features/validation/repeat_passwd';

//Import Action 
import { passwordReset, confirmSMSPasswordReset } from '../../../../action/users';

function ForgetPassword (props) {
  const { backModal } = props;

  const [form, setForm] = useState({
    email: "",
    phone: "",
    type: ""
  });

  const handleChange = e => {
    const { name, value } = e.target;
    setForm({
      ...form,
      [name]: value
    });
  };

  const [error, setError] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [passwdReset, setPasswdReset] = useState(false);
  const [success, setSuccess] = useState(false);
  const [code, setCode] = useState('');
  const [errorCode, setErrorCode] = useState(false);

  const handleSubmit = e => {
    e.preventDefault();

    setError(ValidateRepeatPasswd(form));
    setIsSubmitting(true);
  };

  useEffect(() => {
    if (Object.keys(error).length === 0 && isSubmitting) {
      store.dispatch(passwordReset(form, setSuccess, setPasswdReset));
      setPasswdReset(true);
    }
  }, [error]);

  const handleConfirm = () => {
    if (code) {
      store.dispatch(confirmSMSPasswordReset(code, backModal));
    } else {
      setErrorCode(true)
    }
  }

  return (
    <>
      {
        form.type === 'email' ? 
          !success ? 
            <div className="col-lg-6 mt-8 mb-8 mx-auto">
              <div className="heading mb-1">
                <h2 className="title">Zresetuj hasło</h2>
                <p>Wpisz swój adres e-mail poniżej, aby zresetować hasło.</p>
              </div>
              <form onSubmit={handleSubmit}>
                <label htmlFor="reset-email">Adres e-mail <span className="required">*</span></label>
                <input type="email" name="email" className="form-input form-wide" id="reset-email" onChange={handleChange} value={form.email} />
                {error.email && <span className="text-danger">{error.email}</span>}
                <div className="row mt-2">
                  <div className="col-lg-auto col-auto">
                    <button type="button" className="btn btn-thirdy" onClick={backModal("forget-password")}>Wróć</button>
                  </div>
                  <div className="col-lg-auto col-auto ml-auto">
                    <button type="submit" className="btn btn-primary">Zresetuj hasło</button>
                  </div>
                </div>
              </form>
            </div>
          :
          <div className="col-lg-12 mt-8 mb-8 text-center">
            <h2 style={{fontSize: '4rem'}} className="mb-4">Twoje hasło zostało zresetowane</h2>
            <h3 className="font-weight-normal mb-4" style={{lineHeight: '2'}}>Wysłaliśmy wiadomość email na adres <span className="font-semibold">{form.email}</span>.<br/>Zawiera ona nowe hasło, które należy użyć do zalogowania się na konto.<br/>Po zalogowaniu możesz dokonać zmiany hasła na własne.</h3>
          </div>
        : form.type === 'phone' ? 
          !success ? 
            <div className="col-lg-6 mt-8 mb-8 mx-auto">
              <div className="heading mb-1">
                <h2 className="title">Zresetuj hasło</h2>
                <p>Wpisz swój numer telefonu poniżej, aby otrzymać kod SMS.</p>
              </div>
              <form onSubmit={handleSubmit} style={{ marginBottom: '0' }}>
                <label htmlFor="reset-phone">Telefon <span className="required">*</span></label>
                <input type="tel" maxLength={9} name="phone" className="form-input form-wide" id="reset-phone" onChange={handleChange} value={form.phone} />
                {/* <InputMask mask="99999999999" maskChar={null} className="form-input form-wide" id="reset-phone" name="phone" value={form.phone} onChange={handleChange} /> */}
                {error.phone && <span className="text-danger">{error.phone}</span>}
                <div className="row mt-2">
                  <div className="col-lg-auto col-auto">
                    <button type="button" className="btn btn-thirdy" name="type" value="" onClick={handleChange}>Wróć</button>
                  </div>
                  <div className="col-lg-auto col-auto ml-auto">
                    <button type="submit" className="btn btn-primary">Wyślij kod sms</button>
                  </div>
                </div>
              </form>
            </div>
          :
          <div className="col-lg-12 mt-8 mb-8">
            <h2 style={{fontSize: '4rem'}} className="mb-4 text-center">Prosimy o potwierdzenie zresetowania hasła</h2>
            <h3 className="font-weight-normal mb-2 text-center" style={{lineHeight: '2'}}>Wysłaliśmy wiadomość SMS na numer <span className="font-semibold">{form.phone}</span>.<br/>Zawiera ona kod który trzeba wpisać w polu poniżej, w celu potwierdzenia zresetowania hasła.<br/>W kolejnej wiadomości otrzymasz tymczasowe hasło. Po zalogowaniu dokonaj zmiany hasła na własne.</h3>
            <div className="row justify-content-center mb-2">
              <div className="col-lg-4">
                <input type="text" className="form-input form-wide" onChange={(e) => setCode(e.target.value)} placeholder="Tu wpisz kod SMS" />
                {errorCode && <span className="text-danger">Wpisz kod SMS</span>}
                <button className="btn btn-secondary form-wide mt-1 mb-2" onClick={handleConfirm}>Zresetuj hasło</button>
              </div>
            </div>
          </div>
        : 
        <div className="col-lg-12 mt-8 mb-8 mx-auto text-center">
          <div className="row">
            <div className="col-md-6 mb-3 mb-md-0">
              <div className="heading mb-2">
                <h2 className="title" style={{fontSize:'2.1rem',fontWeight:'700'}}>E-mail</h2>
                <p>Z tej opcji możesz skorzystać jeśli do konta przypisany jest adres e-mail.</p>
              </div>
              <button className="btn btn-primary" name="type" value="email" onClick={handleChange}>Reset za pomocą email</button>
            </div>
            <div className="col-md-6 mb-3 mb-md-0">
              <div className="heading mb-2">
                <h2 className="title" style={{fontSize:'2.1rem',fontWeight:'700'}}>Sms</h2>
                <p>Z tej opcji możesz skorzystać jeśli do konta przypisany jest numer telefonu.</p>
              </div>
              <button className="btn btn-primary" name="type" value="phone" onClick={handleChange}>Reset za pomocą SMS</button>
            </div>
          </div>
        </div>
      }
      {
        passwdReset ? 
          <div className="loading-overlay" style={{background: 'rgba(0,0,0,.7)'}}>
            <div className="bounce-loader">
              <div className="bounce1"></div>
              <div className="bounce2"></div>
              <div className="bounce3"></div>
            </div>
          </div>
        : null
      }
    </>
  )
}

export default ForgetPassword;